var map = {
	"./assinatura": [
		886,
		9,
		991,
		886
	],
	"./assinatura.js": [
		886,
		9,
		991,
		886
	],
	"./contact": [
		665,
		9,
		665
	],
	"./contact.js": [
		665,
		9,
		665
	],
	"./custom": [
		527,
		9,
		527
	],
	"./custom.js": [
		527,
		9,
		527
	],
	"./stores": [
		954,
		7,
		954
	],
	"./stores.js": [
		954,
		7,
		954
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 259;
module.exports = webpackAsyncContext;